import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ILastViewedNotificationStore {
  lastId: number
  setLastId: (id: number) => void
}

export const useLastViewedNotificationStore = create<
  ILastViewedNotificationStore,
  [['zustand/persist', unknown]]
>(
  persist(
    (set) => ({
      lastId: 0,
      setLastId: (id: number) => set({ lastId: id })
    }),
    {
      name: 'last-viewed-notification'
    }
  )
)
